import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { SectionLabel } from './SectionLabel';
import { faqItems } from '../data/content';
export function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="w-full border-y border-ink/10 bg-oat/50" data-id="element-17" data-mp="1gd7gc7wyl95h">
      <div className="mx-auto w-full max-w-3xl px-5 py-12 sm:px-6 sm:py-16 lg:py-24" data-id="element-18" data-mp="1gaurrbwp40jg">
        <SectionLabel data-id="element-19" data-mp="2dyd93b4faaz2">Preguntas frecuentes</SectionLabel>
        <h2 className="font-display text-[1.6rem] leading-tight text-ink sm:text-4xl" data-id="element-20" data-mp="292eg1a85g4sb">
          Todo lo que querés saber antes de empezar
        </h2>

        <dl className="mt-8 space-y-3 sm:mt-10" data-id="element-21" data-mp="24437r3xi62c7">
          {faqItems.map((item, index) => {
          const isOpen = openIndex === index;
          return <div key={item.question} className="overflow-hidden rounded-2xl border border-ink/10 bg-cream" data-id="element-22" data-mp="soob6197hchm" data-mpi={index}>
                <dt data-id="element-23" data-mp="phejs4expfge">
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 px-4 py-4 text-left transition-colors hover:bg-white/60 focus:outline-none focus-visible:ring-2 focus-visible:ring-clay/40 sm:gap-5 sm:px-6 sm:py-5" data-id="element-24" data-mp="pizfvygwd6gd">
                    <span className="font-display text-base leading-snug text-ink sm:text-lg" data-id="element-25" data-mp="6pvefqxftpb7">
                      {item.question}
                    </span>
                    <motion.span animate={{
                  rotate: isOpen ? 45 : 0
                }} transition={{
                  duration: 0.25
                }} className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-sage/20 text-moss" data-id="element-26" data-mp="3szfworz9dgdf">
                      <PlusIcon className="h-4 w-4" aria-hidden="true" data-id="element-27" data-mp="3nzbnzo4ldpxr" />
                    </motion.span>
                  </button>
                </dt>
                <AnimatePresence initial={false} data-id="element-28" data-mp="1ui5ovrq93bfk">
                  {isOpen ? <motion.dd initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3,
                ease: [0.22, 1, 0.36, 1]
              }} className="overflow-hidden" data-id="element-29" data-mp="1ppcn9cq2wj7p">
                      <p className="px-4 pb-4 font-sans text-[15px] leading-relaxed text-ink/70 sm:px-6 sm:pb-5 sm:text-base" data-id="element-30" data-mp="28gvp3g8d9r85">
                        {item.answer}
                      </p>
                    </motion.dd> : null}
                </AnimatePresence>
              </div>;
        })}
        </dl>
      </div>
    </section>;
}